import Http from '@/libs/http';

class FirewallLogApi extends Http {
   index(params) {
      return super.get('cloudfirewall/logs', { params });
   }
}

export default new FirewallLogApi();
